@if (isError) {
  <div class="h-[80%]">
    <app-something-went-wrong
      description="{{ 'cannotLoadMailAccount' | translate }}"
      [showPicture]="false"
      (retryEmitter)="retryData()"></app-something-went-wrong>
  </div>
}

@if (!isError) {
  <div class="flex-col-container-1">
    <div class="search-panel">
      <div class="button-group h-[40px]">
        @if (!iscredemISAMSupport) {
          <button
            mat-raised-button
            color="primary"
            class="page-block-button"
            aria-label="Add user to mail account"
            (click)="onCreateMailAccountUserBtnClicked()">
            <mat-icon class="{{ useMobileView ? '!m-0' : '' }}">add</mat-icon>
            {{ useMobileView ? '' : ('assignUser' | translate) }}
          </button>
        }
        @if (isExporting) {
          <div class="w-[2.5rem]">
            <app-loader
              padding="0"
              [diameter]="'22'"
              height="100%"></app-loader>
          </div>
        } @else {
          <button
            mat-icon-button
            [attr.aria-label]="'exportExcel' | translate"
            (click)="exportExcel()"
            matTooltip="{{ 'exportExcel' | translate }}">
            <i class="far fa-file-excel fa-xs"></i>
          </button>
        }
      </div>
      <div class="search-bar">
        <app-search-bar
          [fullWidth]="useMobileView"
          (searchEventEmitter)="onSearch()"
          (valueChangedEventEmitter)="onSearchValueChanged($event)"
          [search]="searchValue"></app-search-bar>
        @if (!useMobileView) {
          <app-table-header
            [countTotal]="totalSize"
            (reloadEventEmitter)="reload()"
            [isReloadLoading]="isReloadLoading"></app-table-header>
        }
      </div>
    </div>
  </div>
}

@if (useMobileView && !isError && !isLoading) {
  <div class="self-end">
    <app-table-header
      [countTotal]="totalSize"
      (reloadEventEmitter)="reload()"
      (searchOrderChangeEventEmitter)="searchOrderChange($event)"
      (changeOrderEventEmitter)="changeOrder()"
      [searchOrder]="searchOrder"
      [searchOrders]="searchOrders"
      [orderDirection]="filter.orderDirection"
      [isReloadLoading]="isReloadLoading"></app-table-header>
  </div>
  <div class="h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <div class="mobile-container-cards">
        @if (!isLoading) {
          @if (!!dataSource.data.length) {
            @for (userMailAccount of dataSource.data; track userMailAccount) {
              <div class="card">
                <mat-card class="mobile-row">
                  <mat-card-content
                    (click)="onEditMailAccountUserBtnClicked(userMailAccount)"
                    class="flex flex-1 cursor-default">
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'firstName' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ userMailAccount.userFirstName }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'lastName' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ userMailAccount.userLastName }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">Adfs identity:</div>
                      <div class="card-table-row-value">
                        {{ userMailAccount.adfsIdentity }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">Oidc identity:</div>
                      <div class="card-table-row-value">
                        {{ userMailAccount?.oidcIdentity ?? '' }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'email' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ userMailAccount.userEmail }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'role' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ roleTypes[userMailAccount.roleId] | translate }}
                      </div>
                    </div>
                  </mat-card-content>
                  <div class="icons-mobile-block">
                    @if (!iscredemISAMSupport) {
                      <button
                        matTooltip="{{ 'changeRole' | translate }}"
                        mat-icon-button
                        color="primary"
                        aria-label="Change role"
                        (click)="
                          onEditMailAccountUserBtnClicked(userMailAccount)
                        ">
                        <mat-icon>manage_accounts</mat-icon>
                      </button>
                      <button
                        matTooltip="{{ 'delete' | translate }}"
                        mat-icon-button
                        color="primary"
                        aria-label="Delete"
                        (click)="
                          deleteUserMailAccount(
                            userMailAccount.userMailAccountId,
                            userMailAccount.mailAccountName,
                            userMailAccount.userFirstName,
                            userMailAccount.userLastName
                          )
                        ">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    }
                  </div>
                </mat-card>
              </div>
            }
          }
        }
      </div>
      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (!useMobileView && !isLoading && !isError) {
  <div class="settings-table-container h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        (matSortChange)="sortData($event)">
        <ng-container matColumnDef="firstName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'firstName' | translate }}
          </th>
          <td mat-cell *matCellDef="let userMailAccount">
            {{ userMailAccount.userFirstName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'lastName' | translate }}
          </th>
          <td mat-cell *matCellDef="let userMailAccount">
            {{ userMailAccount.userLastName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="GAW">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'GAW' | translate }}
          </th>
          <td mat-cell *matCellDef="let organizationUser">
            {{ organizationUser.oidcIdentity }}
          </td>
        </ng-container>
        <ng-container matColumnDef="adfs">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'adfs' | translate }}
          </th>
          <td mat-cell *matCellDef="let organizationUser">
            {{ organizationUser?.adfsIdentity ?? '' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'email' | translate }}
          </th>
          <td mat-cell *matCellDef="let userMailAccount">
            {{ userMailAccount.userEmail }}
          </td>
        </ng-container>
        <ng-container matColumnDef="role">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'role' | translate }}
          </th>
          <td mat-cell *matCellDef="let userMailAccount">
            {{ roleTypes[userMailAccount.roleId] | translate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'actions' | translate }}</th>
          <td mat-cell *matCellDef="let userMailAccount">
            @if (!iscredemISAMSupport) {
              <button
                mat-icon-button
                [attr.aria-label]="'changeRole' | translate"
                matTooltip="{{ 'changeRole' | translate }}"
                (click)="onEditMailAccountUserBtnClicked(userMailAccount)">
                <mat-icon>manage_accounts</mat-icon>
              </button>
              <button
                mat-icon-button
                [attr.aria-label]="'delete' | translate"
                matTooltip="{{ 'delete' | translate }}"
                (click)="
                  deleteUserMailAccount(
                    userMailAccount.userMailAccountId,
                    userMailAccount.mailAccountName,
                    userMailAccount.userFirstName,
                    userMailAccount.userLastName
                  )
                ">
                <mat-icon>delete_outline</mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="cursor-default"></tr>
      </table>
      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (isLoading) {
  <div class="flex-1 overflow-hidden">
    <app-skeleton-table></app-skeleton-table>
  </div>
}

<ng-template #addDrawer>
  @if (organizationId) {
    <app-mail-account-users-add
      (creationSubmit)="onAddUserToMailAccount()"
      [organizationId]="organizationId"
      (closeEventEmitter)="onCloseEditModalForm()"
      [mailAccountId]="mailAccountId"
      [userMailAccount]="editingUserMailAccount"></app-mail-account-users-add>
  }
</ng-template>
